import React from 'react'
import styled from 'styled-components'

import { CategoryListItem } from '../CategoryList'
import { MysqlCategories, MysqlCategoriesEdge } from '../../graphqlTypes'

const Container = styled.ul`
  border: 1px solid ${({ theme }) => theme.palette.border.light};
  border-radius: 5px;
  box-sizing: border-box;
  list-style: none;
  width: 200px;
  @media (max-width: ${({ theme }) => theme.mediaQuery.mobile.maxWidth}) {
    display: none;
  }
`

const Menu = styled.li`
  &:first-child {
    border-radius: 5px 5px 0 0;
  }
`

const Headline = styled.p`
  background: ${({ theme }) => theme.palette.background.gray};
  color: ${({ theme }) => theme.palette.font.main};
  font-size: 12px;
  font-weight: bold;
  padding: 10px;
`

const CategoryList = styled.ul`
  list-style: none;
`

export default function SidebarLeft({ categories }: { categories: MysqlCategoriesEdge[] }) {
  return (
    <aside>
      <Container>
        {categories
          .filter(({ node }) => node.categories && node.categories.length > 0)
          .map(({ node }, key) => {
            const categories = node.categories as MysqlCategories[]
            return (
              <React.Fragment key={key}>
                <Menu>
                  <Headline>{node.title}</Headline>
                  <CategoryList>
                    {categories.map((child, key) => (
                      <CategoryListItem category={child} to={child.fields!.pagePath!} key={key} />
                    ))}
                  </CategoryList>
                </Menu>
              </React.Fragment>
            )
          })}
      </Container>
    </aside>
  )
}
